import React, { useState, useEffect } from 'react';
import { postsAPI } from '../utils/api';

export default function Explore() {
  const [posts, setPosts]     = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    postsAPI.getExplore()
      .then(r => setPosts(r.data.posts || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page-container">
      <h2 style={{ marginBottom: 'var(--sp-4)', fontSize: 'var(--fs-xl)' }}>Explore</h2>

      {loading ? (
        <div className="explore-grid">
          {Array(12).fill(0).map((_, i) => (
            <div key={i} className="skeleton" style={{ aspectRatio: 1, borderRadius: 'var(--radius)' }} />
          ))}
        </div>
      ) : posts.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 'var(--sp-6) var(--sp-4)', color: 'var(--text-3)' }}>
          <div style={{ fontSize: 'clamp(36px,10vw,54px)', marginBottom: 'var(--sp-3)' }}>🔍</div>
          <p style={{ fontSize: 'var(--fs-md)' }}>Nothing to explore yet. Be the first to post!</p>
        </div>
      ) : (
        <div className="explore-grid">
          {posts.map((p, i) => (
            <div key={p.id} className={"explore-item" + (i % 7 === 0 ? ' large' : '')}>
              {p.media_type === 'video'
                ? <video src={p.media_url} muted style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                : <img src={p.media_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} loading="lazy" />
              }
              <div className="explore-overlay">
                <span>❤️ {p.likes_count}</span>
                <span>💬 {p.comments_count}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
